import {actions} from './actions'

const notificationDefaultState = {
  show: false,
  notification: '',
  variant: 'primary',
  delay: 3000
}

const confirmDefaultState = {
  show: false,
  title: '',
  confirmTitle: '',
  cancelTitle: '',
  message: '',
  onConfirm: () => {},
  onCancel: () => {}
}

const initialState = {
  notification: {
    ...notificationDefaultState
  },
  confirm: {
    ...confirmDefaultState
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.NOTIFY:
      return {
        ...state,
        notification: {
          show: true,
          notification: action.notification,
          variant: action.variant,
          delay: action.delay
        }
      }
    case actions.HIDE_NOTIFICATION:
      return {
        ...state,
        notification: {
          ...notificationDefaultState
        }
      }
    case actions.CONFIRM:
      const {type, ...confirm} = action
      return {
        ...state,
        confirm: {
          show: true,
          ...confirm
        }
      }
    case actions.ON_CONFIRM:
      if (state.confirm.onConfirm) {
        state.confirm.onConfirm()
      }
      return {
        ...state,
        confirm: {
          ...confirmDefaultState
        }
      }
    case actions.ON_CANCEL:
      if (state.confirm.onCancel) {
        state.confirm.onCancel()
      }
      return {
        ...state,
        confirm: {
          ...confirmDefaultState
        }
      }
    default:
      return state
  }
}

export default reducer
